export const PAYMENT_FORM_DISPLAY_NAME_FIELD = 'displayName';
export const ADDRESS_LINE1_FIELD = 'addressLine1';
// export const ADDRESS_LINE2_FIELD = 'addressLine2';
export const ADDRESS_CITY_FIELD = 'addressCity';
export const ADDRESS_STATE_FIELD = 'addressState';
export const ADDRESS_ZIP_FIELD = 'addressZip';
export const ADDRESS_COUNTRY_FIELD = 'addressCountry';
